<div class="bp-modal">
	<bp-modal-header [title]="'enter_card_details' | translate">
		<a (click)="onHeaderButtonClick()" (keydown.enter)="onHeaderButtonClick()" [tabIndex]="0" right>
			{{ "abort" | translate }}
		</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="center-block flex-center-horizontal">
				<app-paysafe [isCheckout]="isCheckout" [checkoutDepositData]="checkoutDepositData">
					<ng-container saveSwitch>
						<label class="input-label" for="save">
							<input
								(ngModelChange)="handleCCSaveChange($event)"
								[(ngModel)]="save"
								class="input-label-checkmark"
								id="save"
								name="save"
								type="checkbox" />
							<span class="input-label-container">
								<span class="input-label input-label__big">{{
									"withdrawal_save_card" | translate
								}}</span>
								<span class="input-label input-label__small">{{
									"withdrawal_save_card_description" | translate
								}}</span>
							</span>
						</label>
					</ng-container>
				</app-paysafe>
			</div>
		</div>
	</div>
</div>
